export class Horse_show_series {

	number: number;
	id: string;
	name: string;
	description: string;
	venue_id: string;
	start_date: Date;
	end_date: Date;
	has_credentialing: boolean;
	horse_show_organizer_id: string;
	
	//Return from Join
	venue_name: string;
	venue_city: string;
	venue_state: string;
	venue_country: string;

	trainer_access: boolean;
	competitor_access: boolean;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}
	
}